/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable"; // Asegúrate de ajustar la ruta
import BuscarUsuario from "./components/BuscarUsuario";
import { formatDate } from "../utils/utils";

const ModalAsignacionSector = ({ isOpen, onClose, sectores, onSave }) => {
    const [asignaciones, setAsignaciones] = useState({});

    // Inicializar estado cuando se abre el modal
    useEffect(() => {
        if (isOpen && sectores.length > 0) {
            const initial = {};
            sectores.forEach(s => initial[s.id] = null);
            setAsignaciones(initial);
        }
    }, [isOpen, sectores]);

    const handleChange = (sectorId, usuario) => {
        setAsignaciones(prev => ({
            ...prev,
            [sectorId]: usuario ? usuario.id : null
        }));
    };

    const handleGuardar = () => {
        // Validar que se hayan seleccionado usuarios (opcional, depende de reglas de negocio)
        // Aquí permitimos guardar, asumiendo que el backend maneja si faltan sectores (o se dejan sin asignar)
        const payload = Object.entries(asignaciones).map(([sectorId, usuarioId]) => ({
            sectorId: parseInt(sectorId),
            usuarioId,
        })).filter(item => item.usuarioId !== null);



        onSave(payload);
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Asignar Sectores / Procedimientos (Nueva Planificación)</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p className="text-muted mb-4">
                            Busque el usuario responsable para cada sector o procedimientos. Esta acción cerrará la planificación anterior y activará la nueva a partir de hoy.
                            <br />
                            <small className="text-danger">* Si se deja vacío, no se asignará nadie al sector.</small>
                        </p>
                        <form>
                            {sectores.map(sector => (
                                <div className="mb-3 row" key={sector.id}>
                                    <label className="col-sm-3 col-form-label fw-bold mt-4">{sector.nombre}</label>
                                    <div className="col-sm-9">
                                        <BuscarUsuario
                                            onSelect={(usuario) => handleChange(sector.id, usuario)}
                                            onClear={() => handleChange(sector.id, null)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={handleGuardar}>Guardar Planificación</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ModalCambioResponsable = ({ isOpen, onClose, asignacion, onSave }) => {
    const [usuarioId, setUsuarioId] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setUsuarioId(null);
        }
    }, [isOpen]);

    if (!isOpen || !asignacion) return null;

    const handleGuardar = () => {
        if (!usuarioId) {
            gdAlertify.notify("Seleccione un enfermero/a.", "error");
            return;
        }

        onSave(asignacion.id, usuarioId);
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Cambiar responsable</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <div className="fw-bold">{asignacion.nombre_sector}</div>
                            <div className="text-muted small">Actual: {asignacion.nombre_usuario || "Sin asignar"}</div>
                        </div>
                        <BuscarUsuario
                            onSelect={(usuario) => setUsuarioId(usuario.id)}
                            onClear={() => setUsuarioId(null)}
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={handleGuardar}>Guardar Cambio</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PlanificacionSector = ({ modal = false, onClose } = {}) => {
    const [historial, setHistorial] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [asignacionCambio, setAsignacionCambio] = useState(null);

    // Cargar datos iniciales
    useEffect(() => {
        fetchHistorial();
        fetchSectores();
    }, []);

    const fetchHistorial = async () => {
        gdAlertify.showLoader();
        try {
            const response = await axiosInstance.get("/planificacion/lista");
            if (response.data && response.data.data) {
                setHistorial(response.data.data);
            }
        } catch (error) {
            console.error(error);
            // gdAlertify.notify("Error cargando historial", "error");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const fetchSectores = async () => {
        try {
            const response = await axiosInstance.get("/planificacion/sectores");
            if (response.data && response.data.data) {
                setSectores(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };



    const handleSavePlanificacion = async (payload) => {
        setIsModalOpen(false); // Cerrar modal inmediatamente
        gdAlertify.showLoader();
        try {
            const response = await axiosInstance.post("/planificacion/guardar", { asignaciones: payload });
            if (!response.data.error) {
                gdAlertify.notify("Planificación guardada correctamente.", "success");
                fetchHistorial(); // Recargar tabla
            } else {
                gdAlertify.notify(response.data.message || "Error al guardar.", "error");
            }
        } catch (error) {
            console.error(error);
            gdAlertify.notify("Error de conexión.", "error");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const handleEliminarAsignacion = (row) => {
        gdAlertify.confirm({
            title: "Eliminar asignacion",
            message: `Desea eliminar la asignacion de ${row.nombre_sector}?`,
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const response = await axiosInstance.post("/planificacion/eliminar-asignacion", { id: row.id });
                    if (!response.data.error) {
                        gdAlertify.notify(response.data.message || "Asignacion eliminada correctamente.", "success");
                        fetchHistorial();
                    } else {
                        gdAlertify.notify(response.data.message || "Error al eliminar asignacion.", "error");
                    }
                } catch (error) {
                    console.error(error);
                    gdAlertify.notify("Error de conexion.", "error");
                } finally {
                    gdAlertify.hideLoader();
                }
            },
            onCancel: () => gdAlertify.notify("Accion cancelada", "info"),
        });
    };

    const handleCambiarResponsable = async (asignacionId, usuarioId) => {
        setAsignacionCambio(null);
        gdAlertify.showLoader();
        try {
            const response = await axiosInstance.post("/planificacion/cambiar-responsable", { id: asignacionId, usuarioId });
            if (!response.data.error) {
                gdAlertify.notify(response.data.message || "Responsable actualizado correctamente.", "success");
                fetchHistorial();
            } else {
                gdAlertify.notify(response.data.message || "Error al actualizar responsable.", "error");
            }
        } catch (error) {
            console.error(error);
            gdAlertify.notify("Error de conexion.", "error");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const columns = [
        { name: "id", title: "#", width: 50 },
        { name: "fecha_inicio", title: "Fecha Inicio", render: (row) => formatDate(row.fecha_inicio), width: 120 },
        { name: "fecha_fin", title: "Fecha Fin", render: (row) => row.fecha_fin ? formatDate(row.fecha_fin) : <span className="badge bg-success">Actual</span>, width: 120 },
        { name: "nombre_sector", title: "Sector / Procedimientos", width: 190 },
        { name: "nombre_usuario", title: "Usuario Asignado" },
        { name: "asignado_por_nombre", title: "Asignado Por", width: 200 },
        {
            name: "id",
            title: "Accion",
            width: 210,
            render: (row) => (
                <div className="d-flex gap-2">
                    {!row.fecha_fin && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => setAsignacionCambio(row)}
                        >
                            <i className="bi bi-pencil-square me-1"></i>
                            Cambiar
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleEliminarAsignacion(row)}
                    >
                        <i className="bi bi-trash me-1"></i>
                        Eliminar
                    </button>
                </div>
            ),
        },
    ];

    const contenido = (
        <>
            <div className={modal ? "modal-header" : "card-header bg-white d-flex justify-content-between align-items-center py-3"}>
                <h4 className="mb-0 text-primary"><i className="bi bi-map me-2"></i>Planificación de Sectores / Procedimientos</h4>
                <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>
                        <i className="bi bi-plus-lg me-2"></i>Nueva Planificación
                    </button>
                    {modal && <button type="button" className="btn-close" onClick={onClose}></button>}
                </div>
            </div>
            <div className={modal ? "modal-body overflow-auto" : "card-body"}>
                <GdTable
                    columns={columns}
                    data={historial}
                    defaultItemsPerPage={20}
                    itemsPerPageOptions={[10, 20, 50]}
                    initialSort={[0, "desc"]}
                />
            </div>
        </>
    );

    const modalesInternos = (
        <>
            <ModalAsignacionSector
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                sectores={sectores}
                onSave={handleSavePlanificacion}
            />
            <ModalCambioResponsable
                isOpen={!!asignacionCambio}
                onClose={() => setAsignacionCambio(null)}
                asignacion={asignacionCambio}
                onSave={handleCambiarResponsable}
            />
        </>
    );

    if (modal) {
        return (
            <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
                <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: "90vw", width: "90vw", maxHeight: "90vh", margin: "5vh auto" }}>
                    <div className="modal-content" style={{ maxHeight: "90vh" }}>
                        {contenido}
                    </div>
                </div>
                {modalesInternos}
            </div>
        );
    }

    return (
        <div className="container-fluid mt-5">
            <div className="card shadow-sm">
                {contenido}
            </div>
            {modalesInternos}
        </div>
    );
};

export default PlanificacionSector;
